"use client";

import { forwardRef } from "react";
import styled from "styled-components";
import { sans } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const Button = styled.button.withConfig({
  componentId: "sc-1v62o0r-0"
})(["background:0;border:0;padding:0;margin:0;text-align:inherit;cursor:pointer;color:inherit;font-family:", ";text-decoration:none;&[disabled]{cursor:not-allowed;}"], sans);

/**
 * Use when a button is needed for accessibility purposes but no button styles are desired.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - The button contents
 * @param {boolean} [props.disabled] - If the button should be disabled
 * @param {string} [props.href] - The link that the button should navigate to on click
 * @param {React.ElementType} [props.renderAs] - The HTML tag string or React component to render as. By default, if `href` is present and it is not `disabled`, it will render as an `<a>`. Otherwise it will default to `<button>`.
 * @param {string} [props.type] - The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes) or the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes).
 * @param {React.Ref} ref - Ref forwarded to the underlying element.
 * @returns {React.ReactElement} The button element
 */
const A11yComponent = ({
  href,
  disabled,
  renderAs = href && !disabled ? "a" : "button",
  type = renderAs === "button" ? "button" : undefined,
  ...props
}, ref) => /*#__PURE__*/_jsx(Button, {
  ...props,
  ref: ref,
  type: type,
  href: href,
  disabled: disabled,
  as: renderAs,
  children: props.children
});
const A11y = /*#__PURE__*/forwardRef(A11yComponent);
A11y.displayName = "A11y";
export default A11y;